module.exports = __webpack_public_path__ + "static/img/yinliangjia2.71dde37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/yinliangjia2.png
// module id = c/J5
// module chunks = 24